import React, { useEffect, useState } from "react";
import { ModalClose, DisabledPrompt, useBCMSModal } from "bcms-react"
import CustomModal, { CustomModalContent, CustomModalFooter, ModalPrimaryButton, ModalSecondaryButton } from "../..";
import { FormContainer, FormRowView } from "components/shared";
import { PrimaryButton, SecondaryButton, UITextInput } from "components/ui";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import ACHParticipantsTable from "./components/ACHParticipantsTable";
import MobileACHParticipantsTable from "./components/MobileACHParticipantsTable";

import "./styles.css";
import "./mobile.css";
import { Participant } from "model";

/**
 * @function ACHParticipantsModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the ACHParticipantsModal
 */
export default function ACHParticipantsModal(props) {
    const { close } = useBCMSModal();
    const data = props.data ?? {};
    let participants = data.participants ?? [];
    const modalTitle = data.modalTitle ?? "Participants";
    const onParticipantModalCancelClick = data.onParticipantModalCancelClick ?? (() => {});
    const onParticipantsModalAddSelectedParticipantsClick = data.onParticipantsModalAddSelectedParticipantsClick ?? (() => {});
    const [ groupSearchVal, setGroupSearchVal ] = useState(data.groupSearchValue ?? "");
    const [ stateParticipants, setStateParticipants ] = useState({
        participants: participants,
        filteredParticipantsInSearch: participants
    });

    const onGroupInputSearch = val => {
        setGroupSearchVal(val);
    }

    const onFilterButtonClick = () => {
        const filteredParticipants = participants.filter(item => {
            return groupSearchVal === "" || item.group.toLowerCase().includes(groupSearchVal.toLowerCase());
        });
        
        setStateParticipants({ ...stateParticipants, filteredParticipantsInSearch: filteredParticipants });
    };

    const onClearButtonClick = () => {
        setGroupSearchVal("");
        setStateParticipants({ participants: participants, filteredParticipantsInSearch: participants });
    };
    
    // If button "Add Selected Participant" is clicked, 
    // close the modal if no participants are selected.
    const closeModal = () => {
        const currFilteredParticipantsInSearch = stateParticipants.filteredParticipantsInSearch.filter(item => item.isSelected === "true");

        if(currFilteredParticipantsInSearch.length > 0) {
            onParticipantsModalAddSelectedParticipantsClick(currFilteredParticipantsInSearch);
        }
        
        onParticipantModalCancelClick();
        close("ACHParticipantsModal");
    };

    const stateOnSelectAllParticipantsCheckboxChange = val => {
        const filteredParticipants = stateParticipants.filteredParticipantsInSearch.reduce((acc, item) => {
            acc.push(
                Participant.init({ ...item.record, isSelected: val ? "true" : undefined })
            )
            return acc;
        }, []);
        
        setStateParticipants({ ...stateParticipants, filteredParticipantsInSearch: filteredParticipants });
    }
    const stateOnParticipantRowChange = participant => val => {
        const filteredParticipants = stateParticipants.filteredParticipantsInSearch.reduce((acc, item) => {
            if(item.id === participant.id) {
                acc.push(
                    Participant.init({ ...item.record, isSelected: val ? "true" : undefined })
                );
            } else {
                acc.push(item);
            }
            return acc;
        }, []);
        
        setStateParticipants({ ...stateParticipants, filteredParticipantsInSearch: filteredParticipants });
    }

    const closeModalOnly = () => {
        onParticipantModalCancelClick();
        close("ACHParticipantsModal");
    }
    
    return (
        <CustomModal title={ modalTitle } id="ACHParticipantsModal" className="ach-participants-modal" onCloseClick={ closeModalOnly }>
            <CustomModalContent>
                <FormContainer className="small-form-width">
                    <FormRowView text="Group">
                        <UITextInput value={ groupSearchVal } onChange={ onGroupInputSearch } dataPoint="Group_Search_Field" />
                    </FormRowView>
                    <FormButtonRow>
                    <SecondaryButton text="Clear" onClick={ onClearButtonClick } />
                        <PrimaryButton text="Filter" dataPoint={ `ACH_Participants_Modal_Filter_Button` } onClick={ onFilterButtonClick } />
                    </FormButtonRow>
                </FormContainer>

                <div className="show-on-desktop">
                    <ACHParticipantsTable participants={ stateParticipants.filteredParticipantsInSearch } onParticipantRowChange={ stateOnParticipantRowChange }
                    onSelectAllParticipantsCheckboxChange={ stateOnSelectAllParticipantsCheckboxChange } />
                </div>
                <div className="show-on-mobile">
                    <MobileACHParticipantsTable participants={ stateParticipants.filteredParticipantsInSearch } onParticipantRowChange={ stateOnParticipantRowChange }
                    onSelectAllParticipantsCheckboxChange={ stateOnSelectAllParticipantsCheckboxChange } />
                </div>
                
            </CustomModalContent>
            <CustomModalFooter className="custom-modal-footer button-container">
                <ModalClose id="ACHParticipantsModal">
                    <ModalSecondaryButton text="Cancel" dataPoint={ `ACH_Participants_Modal_Cancel_Button` } onClick={ closeModalOnly } />
                </ModalClose>
                <DisabledPrompt>
                    <ModalPrimaryButton text="New Participant" dataPoint={ `ACH_Participants_Modal_New_Participant_Button` } />
                </DisabledPrompt>
                { stateParticipants.participants.length !== 0 && 
                <ModalPrimaryButton text="Add Selected Participants" dataPoint={ `ACH_Participants_Modal_Add_Selected_Participants_Button` }onClick={ closeModal } />}
            </CustomModalFooter>
        </CustomModal>
    )
}